import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { getStyles } from "src/styles/theme";
import defaultStyles from "./styles";

export type NewSelectedTableProps = {
  topHeader: string[];
  header: string[];
  data: any;
};

export function NewSelectedDashBoardTable({
  data,
  header,
  topHeader,
}: NewSelectedTableProps) {
  const styles = getStyles(defaultStyles);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 600 }} aria-label="simple table">
        <TableHead {...styles("header")}>
          <TableRow>
            {topHeader.map((item, index) => (
              <TableCell
                align="center"
                {...styles("cell")}
                key={index}
                colSpan={2}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            {header.map((item, index) => (
              <TableCell align="center" {...styles("cell")} key={index}>
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row: any, index: number) => (
            <TableRow key={index}>
              <TableCell align="center" {...styles("cell")}>
                {row.sno}
              </TableCell>
              <TableCell align="center" {...styles("cell", { width: "180px" })}>
                {row.state}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberAllIncludingDeselect}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaAllIncludingDeselect}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberNewSelected}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaNewSelected}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberProvisionalSelected}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaProvisionalSelected}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberSiteVisited}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaSiteVisited}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberAcknowledgeByApprover}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaAcknowledgeByApprover}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalNumberDeselect}
              </TableCell>
              <TableCell align="center" {...styles("cell")}>
                {row.totalAreaDeselect}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
